<!-- Modal (Legendas) -->

<ng-template #legendas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-legendas"><b>Legendas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="d-flex flex-column">
      <div class="d-flex align-items-center mb-2">
        <div class="legenda_status_deslogado quadro_perfil_status_deslogado mr-2"></div>
        <div class="legenda_descricao">Deslogado</div>
      </div>

      <div class="d-flex align-items-center mb-2">
        <div class="legenda_status_em_atendimento quadro_perfil_status_em_atendimento mr-2"></div>
        <div class="legenda_descricao">Em Atendimento</div>
      </div>

      <div class="d-flex align-items-center mb-2">
        <div class="legenda_status_em_chamada quadro_perfil_status_em_chamada mr-2"></div>
        <div class="legenda_descricao">Em Chamada</div>
      </div>

      <div class="d-flex align-items-center mb-2">
        <div class="legenda_status_em_pausa quadro_perfil_status_em_pausa mr-2"></div>
        <div class="legenda_descricao">Em Pausa</div>
      </div>

      <div class="d-flex align-items-center mb-2">
        <div class="legenda_status_logado quadro_perfil_status_logado mr-2"></div>
        <div class="legenda_descricao">Logado</div>
      </div>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Pausas Realizadas) -->

<ng-template #pausasRealizadas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-pausas-realizadas"><b>Pausas Realizadas</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-row">
      <div class="form-group col-sm-12">
        <label><b>Vendedor(a):</b></label>

        <input class="form-control form-control-sm" type="text" name="vendedor" [value]="pausas.length > 0 ? pausas[0].fullname : ''" disabled />
      </div>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th>Motivo</th>
            <th class="text-center tabela_borda">Data</th>
            <th class="text-center tabela_borda">Tempo</th>
            <th class="text-center tabela_borda">Hr. Inicial</th>
            <th class="text-center tabela_borda">Hr. Final</th>
          </tr>
        </thead>

        <tbody>
          @for (vendedorPausa of vendedorPausas; track vendedorPausa) {
            <tr>
              <td>{{ vendedorPausa.nome }}</td>
              <td class="text-center tabela_borda">{{ vendedorPausa.data_criacao_usuario | date: 'dd/MM/yyyy' }}</td>
              <td class="text-center tabela_borda">{{ vendedorPausa.tempo_pausa }}</td>
              <td class="text-center tabela_borda">{{ vendedorPausa.hr_inicial_pausa }}</td>
              <td class="text-center tabela_borda">{{ vendedorPausa.hr_final_pausa }}</td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<div class="container-fluid p-0" [@esvanecerDesvanecer]="'in'">
  <!-- Título -->

  <div class="bg-light pt-3 pr-4 pb-3 pl-4">
    <div class="d-flex flex-wrap justify-content-between">
      <div class="flex-grow-1 titulo_texto_posicao">
        <div class="titulo_texto">Dashboard - Call Center (Painel Gerencial)</div>
      </div>

      <div class="d-flex flex-wrap flex-grow-1 justify-content-end">
        <button class="btn btn-secondary btn_titulo" type="button" (click)="modalLegendas(legendas)">Legendas</button>
        <button class="btn btn-info btn_titulo" type="button" (click)="atualizar()">Atualizar</button>
      </div>
    </div>
  </div>

  <div class="pt-2 pr-4 pb-4 pl-4">
    <div class="table-responsive">
      <table class="table table-sm">
        <thead>
          <tr>
            <th class="text-center" colspan="3">Agendado</th>
            <th class="text-center tabela_borda" colspan="3">Gerado</th>
            <th class="text-center tabela_borda">Manual</th>
            <th class="text-center tabela_borda" colspan="2">Total</th>
            <th class="text-center tabela_borda" colspan="4">Resultado</th>
            <th class="text-center tabela_borda" colspan="3">Vendas Externas</th>
            <th class="text-center tabela_borda" colspan="3">Vendas Internas</th>
            <th class="text-center tabela_borda" colspan="2">Total</th>
            <th class="tabela_borda"></th>
          </tr>

          <tr>
            <th class="text-center">Qtde</th>
            <th class="text-center tabela_borda">Realizado</th>
            <th class="text-right tabela_borda">%</th>

            <th class="text-center tabela_borda">Qtde</th>
            <th class="text-center tabela_borda">Realizado</th>
            <th class="text-right tabela_borda">%</th>

            <th class="text-center tabela_borda">Qtde</th>

            <th class="text-center tabela_borda bg_tabela_secondary">Realizado</th>

            <th class="text-center tabela_borda bg_tabela_secondary">Pausas</th>

            <th class="text-center tabela_borda bg_tabela_success">Venda Realizada</th>
            <th class="text-right tabela_borda bg_tabela_success">%</th>
            <th class="text-center tabela_borda bg_tabela_danger">Não Comprou</th>
            <th class="text-right tabela_borda bg_tabela_danger">%</th>

            <th class="text-right tabela_borda bg_tabela_warning">Valor</th>
            <th class="text-center tabela_borda bg_tabela_warning">Litragem</th>
            <th class="text-right tabela_borda bg_tabela_warning">%</th>

            <th class="text-right tabela_borda bg_tabela_warning">Valor</th>
            <th class="text-center tabela_borda bg_tabela_warning">Litragem</th>
            <th class="text-right tabela_borda bg_tabela_warning">%</th>

            <th class="text-right tabela_borda bg_tabela_info">Valor</th>
            <th class="text-right tabela_borda bg_tabela_info">Litragem</th>

            <th class="text-center tabela_borda">Atualização</th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td class="text-center"><b>{{ qtdeTotalAgendado }}</b></td>
            <td class="text-center tabela_borda"><b>{{ qtdeTotalAgendadoRealizado }}</b></td>
            <td class="text-right tabela_borda"><b>{{ porcentagemQtdeTotalAgendadoRealizado | currency: 'BRL' : '' }}%</b></td>

            <td class="text-center tabela_borda"><b>{{ qtdeTotalGerado }}</b></td>
            <td class="text-center tabela_borda"><b>{{ qtdeTotalGeradoRealizado }}</b></td>
            <td class="text-right tabela_borda"><b>{{ porcentagemQtdeTotalGeradoRealizado | currency: 'BRL' : '' }}%</b></td>

            <td class="text-center tabela_borda"><b>{{ qtdeTotalManual }}</b></td>

            <td class="text-center tabela_borda"><b>{{ qtdeTotalRealizado }}</b></td>

            <td class="text-center tabela_borda"><b>{{ qtdeTotalPausa }}</b></td>

            <td class="text-center tabela_borda bg_tabela_success"><b>{{ qtdeVendaRealizada }}</b></td>
            <td class="text-right tabela_borda bg_tabela_success"><b>{{ porcentagemQtdeVendaRealizada | currency: 'BRL' : '' }}%</b></td>
            <td class="text-center tabela_borda bg_tabela_danger"><b>{{ qtdeNaoComprou }}</b></td>
            <td class="text-right tabela_borda bg_tabela_danger"><b>{{ porcentagemQtdeNaoComprou | currency: 'BRL' : '' }}%</b></td>

            <td class="text-right tabela_borda bg_tabela_warning"><b>{{ vendasExternas | currency: 'BRL' }}</b></td>
            <td class="text-center tabela_borda bg_tabela_warning"><b>{{ litragemExterna | currency: 'BRL' : '' }}</b></td>
            <td class="text-right tabela_borda bg_tabela_warning"><b>{{ porcentagemVendasExternas | currency: 'BRL' : '' }}%</b></td>

            <td class="text-right tabela_borda bg_tabela_warning"><b>{{ vendasInternas | currency: 'BRL' }}</b></td>
            <td class="text-center tabela_borda bg_tabela_warning"><b>{{ litragemInterna | currency: 'BRL' : '' }}</b></td>
            <td class="text-right tabela_borda bg_tabela_warning"><b>{{ porcentagemVendasInternas | currency: 'BRL' : '' }}%</b></td>

            <td class="text-right tabela_borda bg_tabela_info"><b>{{ vendasTotal | currency: 'BRL' }}</b></td>
            <td class="text-right tabela_borda bg_tabela_info"><b>{{ litragemTotal | currency: 'BRL' : '' }}</b></td>

            <td class="text-center tabela_borda"><b>{{ dataHora | date: 'HH:mm:ss' }}</b></td>
          </tr>
        </tbody>
      </table>
    </div>

    <hr class="mt-2 mb-2" />

    <div class="d-flex flex-wrap justify-content-center">
      @for (vendedorStatus of vendedoresStatus; track vendedorStatus) {
        <div class="quadro">
          <div class="d-flex flex-column">
            <!-- Perfil -->
            <div class="quadro_perfil p-2" [ngClass]="!vendedorStatus.status_portal ? 'quadro_perfil_status_deslogado' : vendedorStatus.em_atendimento ? 'quadro_perfil_status_em_atendimento' : vendedorStatus.pausado ? 'quadro_perfil_status_em_pausa' : vendedorStatus.status_chamada ? 'quadro_perfil_status_em_chamada' : 'quadro_perfil_status_logado'" placement="top" [ngbTooltip]="!vendedorStatus.status_portal ? 'Deslogado' : vendedorStatus.em_atendimento ? 'Em Atendimento' : vendedorStatus.pausado ? 'Em Pausa' : vendedorStatus.status_chamada ? 'Em Chamada' : 'Logado'">
              <div class="d-flex justify-content-between align-items-center">
                <div class="mr-2">
                  <img class="quadro_perfil_foto" [src]="vendedorStatus.seller_foto" alt="Foto" />
                </div>
                <div class="flex-grow-1">
                  <div class="d-flex flex-column">
                    <div>
                      <b>{{ vendedorStatus.fullname }}</b>
                    </div>
                    <div>
                      @if (vendedorStatus.status_discador) {
                        <div class="quadro_perfil_status_discador">
                          <b>DISCADOR ATIVO</b>
                        </div>
                      }
                      @if (!vendedorStatus.status_discador) {
                        <div class="quadro_perfil_status_discador">
                          <b>DISCADOR INATIVO {{ vendedorStatus.minutos_pausa_texto }}</b>
                        </div>
                      }
                    </div>
                    @if (vendedorStatus.ultima_ligacao != null) {
                      <div>
                        <span class="badge badge-dark quadro_perfil_ultima_ligacao">{{ vendedorStatus.ultima_ligacao | date: 'HH:mm:ss' }}</span>
                      </div>
                    }
                    @if (vendedorStatus.ultima_ligacao == null) {
                      <div>
                        <span class="badge badge-dark quadro_perfil_ultima_ligacao">-</span>
                      </div>
                    }
                  </div>
                </div>
                <div class="ml-2">
                  <div class="d-flex flex-column align-items-end">
                    <div>
                      @if (vendedorStatus.call_center_discador_automatico) {
                        <i class="fa fa-pause btn_tabela_acao"  placement="top" ngbTooltip="Discador Manual" (click)="alterarCallCenterDiscadorAutomatico(vendedorStatus.id, false)"></i>
                      }
                      @if (!vendedorStatus.call_center_discador_automatico) {
                        <i class="fa fa-play btn_tabela_acao"  placement="top" ngbTooltip="Discador Automático" (click)="alterarCallCenterDiscadorAutomatico(vendedorStatus.id, true)"></i>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Dados -->
            <div class="m-2">
              <table class="quadro_dados">
                <tr>
                  <td>Agendado</td>
                  <td class="text-center">{{ vendedorStatus.qtde_agendado }}</td>
                  <td class="text-right"></td>
                </tr>
                <tr>
                  <td>Gerado</td>
                  <td class="text-center">{{ vendedorStatus.qtde_gerado }}</td>
                  <td class="text-right"></td>
                </tr>
                <tr class="quadro_dados_realizado">
                  <td>Realizado (Agendado)</td>
                  <td class="text-center">{{ vendedorStatus.qtde_realizado_agendado }}</td>
                  <td class="text-right">{{ vendedorStatus.porcentagem_realizado_agendado | currency: 'BRL' : '' }}%</td>
                </tr>
                <tr class="quadro_dados_realizado">
                  <td>Realizado (Gerado)</td>
                  <td class="text-center">{{ vendedorStatus.qtde_realizado_gerado }}</td>
                  <td class="text-right">{{ vendedorStatus.porcentagem_realizado_gerado | currency: 'BRL' : '' }}%</td>
                </tr>
                <tr class="quadro_dados_realizado">
                  <td>Realizado (Manual)</td>
                  <td class="text-center">{{ vendedorStatus.qtde_manual }}</td>
                </tr>
                <tr class="quadro_dados_realizado">
                  <td>Realizado (Total)</td>
                  <td class="text-center">{{ vendedorStatus.qtde_total_realizado }}</td>
                </tr>
                <tr class="quadro_dados_com_venda">
                  <td>Venda Realizada</td>
                  <td class="text-center">{{ vendedorStatus.qtde_venda_realizada }}</td>
                  <td class="text-right">{{ vendedorStatus.porcentagem_venda_realizada | currency: 'BRL' : '' }}%</td>
                </tr>
                <tr class="quadro_dados_com_venda">
                  <td>Vendas Total</td>
                  <td></td>
                  <td class="text-right">{{ vendedorStatus.vendas_total | currency: 'BRL' }}</td>
                </tr>
                @if (vendedorStatus.litragem_total > 0) {
                  <tr class="quadro_dados_com_venda">
                    <td>Litragem Total</td>
                    <td></td>
                    <td class="text-right">{{ vendedorStatus.litragem_total | currency: 'BRL' : '' }}</td>
                  </tr>
                }
                <tr class="quadro_dados_sem_venda">
                  <td>Não Comprou</td>
                  <td class="text-center">{{ vendedorStatus.qtde_nao_comprou }}</td>
                  <td class="text-right">{{ vendedorStatus.porcentagem_nao_comprou | currency: 'BRL' : '' }}%</td>
                </tr>
                <tr>
                  <td>
                    Pausa<i class="fa fa-info quadro_acoes ml-2" placement="right" ngbTooltip="Pausas Realizadas" (click)="modalPausasRealizadas(pausasRealizadas, vendedorStatus.id)"></i>
                  </td>
                  <td class="text-center">{{ vendedorStatus.qtde_pausa }}</td>
                  <td class="text-right"></td>
                </tr>
                <tr>
                  <td><b>Em Atendimento</b></td>
                  <td class="text-center"><b>{{ vendedorStatus.tempo_em_atendimento }}</b></td>
                  <td class="text-right"></td>
                </tr>
                <tr>
                  <td><b>Em Atendimento (Média)</b></td>
                  <td class="text-center"><b>{{ vendedorStatus.tempo_medio_em_atendimento }}</b></td>
                  <td class="text-right"></td>
                </tr>
                <tr>
                  <td>Tempo Médio (Pausa)</td>
                  <td class="text-center">{{ vendedorStatus.tempo_medio_pausa }}</td>
                  <td class="text-right"></td>
                </tr>
                <tr>
                  <td class="text-center" colspan="3">
                    <b>E:</b> {{ vendedorStatus.qtde_email }} / <b>F:</b> {{ vendedorStatus.qtde_feita }} / <b>R:</b> {{ vendedorStatus.qtde_recebida }} / <b>W:</b> {{ vendedorStatus.qtde_whatsapp }}
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>
